import * as React from 'react';
import logoDark from '../../images/logos/logo-dark-theme.png';
import logoLight from '../../images/logos/logo-light-theme.png';

/**
 * Full-screen boot splash. Shown while auth / user / workspace context
 * resolves — i.e. before the MUI ThemeProvider may have mounted — so it
 * reads the persisted theme straight from localStorage and styles itself
 * with plain CSS (see the .splash-* rules in App.css).
 */
const MessagePage = ({ text }) => {
    const isDark = (localStorage.getItem('theme') || 'dark') !== 'light';

    return (
        <div className={`splash-page ${isDark ? 'splash-dark' : 'splash-light'}`}>
            <div className="splash-center">
                <img
                    className="splash-logo"
                    src={isDark ? logoDark : logoLight}
                    alt="Predict.ai"
                />
                <div className="splash-wordmark">
                    Predict<span className="splash-accent">.ai</span>
                </div>
                {text ? <div className="splash-text">{text}</div> : null}
            </div>
        </div>
    );
};

export default MessagePage;
